var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M148 89.1s12.2.2 16 3.7c2.1 2 2.2 5.9 2.2 7.9s0 5.9-2.2 7.9c-3.8 3.5-16 3.7-16 3.7h-.9c-1.4 5.1-3.6 9.9-6.5 14.2l.2.2s8.5 8.8 8.7 13.9c.1 2.9-2.6 5.7-4 7.1s-4.2 4.2-7.1 4c-5.1-.2-13.9-8.7-13.9-8.7l-.7-.7c-4.5 2.5-9.4 4.4-14.6 5.5v.4s-.2 12.2-3.7 16c-2 2.1-5.9 2.2-7.9 2.2s-5.9 0-7.9-2.2c-3.5-3.8-3.7-16-3.7-16v-1.1c-5.1-1.4-9.9-3.6-14.2-6.4l-.2.3s-8.8 8.5-13.9 8.7c-2.9.1-5.7-2.6-7.1-4s-4.2-4.2-4-7.1c.2-5.1 8.7-13.9 8.7-13.9l.7-.8c-2.6-4.4-4.4-9.3-5.5-14.5h-.2s-12.2-.2-16-3.7c-2.1-2-2.2-5.9-2.2-7.9s0-5.9 2.2-7.9c3.8-3.5 16-3.7 16-3.7h.8c1.4-5.2 3.6-10 6.4-14.4 0 0-8.5-8.8-8.7-13.9-.1-2.9 2.6-5.7 4-7.1s4.2-4.2 7.1-4c5.1.2 13.9 8.7 13.9 8.7l.5.5c4.5-2.6 9.5-4.5 14.8-5.6v.1s.2-12.2 3.7-16c2-2.1 5.9-2.2 7.9-2.2s5.9 0 7.9 2.2c3.5 3.8 3.7 16 3.7 16v.6c5.2 1.4 10.1 3.6 14.4 6.5v.1s8.8-8.5 13.9-8.7c2.9-.1 5.7 2.6 7.1 4s4.2 4.2 4 7.1C151.5 65.2 143 74 143 74l-.5.5c2.5 4.4 4.4 9.4 5.5 14.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M124.3 74.1c-6.4-6.4-15.3-10.4-25.1-10.4-11 0-20.9 5-27.4 13M124.3 124c-6.4 6.4-15.3 10.4-25.1 10.4-11 0-20.9-5-27.4-13M118.4 109.2V90.5M104.1 90.3c-2.6 0-5.2-.1-5.3 1.4-.2 2.6 0 17.5 0 17.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M104.3 90.3c3.1 0 5.6 2.1 5.6 5.2s-2.5 5.6-5.6 5.6h-4M89.4 109.2s.2-14.1 0-16.7c-.1-1.5-2.7-2.7-5.3-2.7s-5.2 1.2-5.3 2.7c-.2 2.6 0 16.7 0 16.7M78.6 101.1h10.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.49637ddfa2ee690e0ca521c4590b3dea.svg";
export { ForwardRef as ReactComponent };